export default {
  ONBOARDING_CREATE_CUSTOMER_AGREEMENT_REPOSITORY:
    Symbol.for('ONBOARDING_CREATE_CUSTOMER_AGREEMENT_REPOSITORY'),
  ONBOARDING_CREATE_CUSTOMER_AGREEMENT_COMMAND:
    Symbol.for('ONBOARDING_CREATE_CUSTOMER_AGREEMENT_COMMAND'),
};
